
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

import type { SelectOptions } from 'shared/types'
import { normalizeSelectOptions } from 'shared/util'
import { bus } from 'shared/state/Bus'

@Component
export default class SelectControl extends Vue {

	@Prop() label?: string
	@Prop() name!: string
	@Prop({ type: [Array, Object] }) options!: SelectOptions
	@Prop() value!: string

	updatedOptions = []
	bus = bus

	get selectOptions() {
		if(this.updatedOptions.length) { return this.updatedOptions }
		return normalizeSelectOptions(this.options).map(o => ({
			text: o.label,
			value: o.value
		}))
	}

	updateOptions(controlName, options) {
		if(this.label === controlName) {
			this.updatedOptions = options
			this.$emit('change')
		}
	}

	created() {
		bus.$on('update_options', this.updateOptions)
	}

	mounted() {
		const s = document.getElementById('select-' + this.label)
		if(s) { s.click() }
	}

	beforeDestroy() {
		bus.$off('update_options', this.updateOptions)
	}
}
